// src/components/PrivateRoute.js
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";

const PrivateRoute = ({ children }) => {
    const token = Cookies.get("accessToken");

    // Nếu không có token => redirect về login
    if (!token) {
        return <Navigate to="/login" />;
    }

    // Nếu có token => hiển thị nội dung
    return children;
};

export default PrivateRoute;
